// =============================================================================
// Live search.
//
// The desk types a name and waits, then looks for a button. Staff reported the
// search box "not working" when in fact it was working and had simply not been
// submitted — so typing now runs the search itself.
//
// Two things stop that being worse than the button:
//   1. A debounce, so a six-letter name is one request rather than six.
//   2. A sequence number, so a slow request for "an" cannot land after the fast
//      one for "anna" and put the wrong list on screen.
//
// The form's submit still works: pressing Enter runs the pending search now.
// =============================================================================

export function liveSearch(input, run, { delay = 250, min = 0 } = {}) {
  let timer = null;
  let seq = 0;

  async function fire(term) {
    const mine = ++seq;
    await run(term, () => mine === seq);
  }

  function schedule() {
    clearTimeout(timer);
    const term = input.value.trim();
    // Clearing the box is not a search worth waiting for — show everything back
    // immediately rather than after a quarter second of a stale list.
    if (!term) { fire(''); return; }
    if (term.length < min) return;
    timer = setTimeout(() => fire(term), delay);
  }

  input.addEventListener('input', schedule);

  return {
    now() { clearTimeout(timer); fire(input.value.trim()); },
    stop() { clearTimeout(timer); seq++; },
  };
}
